"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Index {
    constructor(parent) {
        this.parent = parent;
        this.rc = parent.rc;
    }
    path() {
        return `${this.parent.path()}/search`;
    }
    /**
     * Returns contact information on corporate users of federated accounts according to the specified filtering and ordering.
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/directory/entries/search
     * Rate Limit Group: Heavy
     * App Permission: ReadAccounts
     * User Permission: ReadExtensions
     */
    async post(searchDirectoryEntriesRequest, queryParams, restRequestConfig) {
        const r = await this.rc.post(this.path(), searchDirectoryEntriesRequest, queryParams, restRequestConfig);
        return r.data;
    }
}
exports.default = Index;
//# sourceMappingURL=index.js.map